document.addEventListener("DOMContentLoaded", function() {
  // Find the trigger link and modal element
  var shippingLink = document.querySelector(".open-shipping-modal");
  var shippingModal = document.getElementById("shippingModal");

  if (shippingLink && shippingModal) {
    shippingLink.addEventListener("click", function(e) {
      e.preventDefault();
      shippingModal.style.display = "flex"; // Using flex to center the content
    });
  }

  // Add listener for the close button
  var closeButton = shippingModal ? shippingModal.querySelector(".close_popup") : null;
  if (closeButton) {
    closeButton.addEventListener("click", function() {
      shippingModal.style.display = "none";
    });
  }

  // Optionally, close the modal when clicking outside of the modal content
  shippingModal.addEventListener("click", function(e) {
    if (e.target === shippingModal) {
      shippingModal.style.display = "none";
    }
  });

});
